import { render } from "./composite-chart.vue?vue&type=template&id=2f09d37e"
import script from "./composite-chart.vue?vue&type=script&lang=ts"
export * from "./composite-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script